export const AUTO_COMPLETE_REQUEST = 'AUTO_COMPLETE_REQUEST';
export const AUTO_COMPLETE_SUCCESS = 'AUTO_COMPLETE_SUCCESS';
export const AUTO_COMPLETE_FAILURE = 'AUTO_COMPLETE_FAILURE';
export const AUTO_COMPLETE_RESET = 'AUTO_COMPLETE_RESET';
export const KEYCODES = {
  ENTER: 13,
  FWD_SLASH: 47,
  BACK_SLASH: 46,
  ESC: 27,
};
export const TRIGGERS = {
  INPUT_FOCUS: 'INPUT_FOCUS',
  INPUT_CHANGE: 'INPUT_CHANGE',
  ITEM_SELECT: 'ITEM_SELECT',
  INPUT_CLEAR: 'INPUT_CLEAR',
  COMPONENT_DID_MOUNT: 'COMPONENT_DID_MOUNT',
};



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/AutoComplete/AutoCompleteConstants.js